import * as React from 'react'

import { observer } from 'mobx-react'

import { IMapSettings } from '~/client/src/shared/components/MapBoxViewer/mapSettings'

import MapSettingsDrawer from './MapSettingsDrawer'
import MapSettingsPopover from './MapSettingsPopover'

type IMapSettingsModalProps = {
  trigger: React.ReactElement
  settings: IMapSettings
  isMobile?: boolean
}

const MapSettingsModal: React.FC<IMapSettingsModalProps> = observer(
  ({ isMobile, ...props }) => {
    if (isMobile) {
      return <MapSettingsDrawer {...props} />
    }

    return <MapSettingsPopover {...props} />
  },
)

export default MapSettingsModal
